<template>
  <div class="insight-company-page-wrapper">
    <!-- asset name -->
    <div class="asset-header-section">
      <h2 class="asset-header">{{assetInfo.name}} ({{assetInfo.ticker}})</h2>
      <p class="asset-type">{{assetInfo.exchange}}</p>
    </div>

    <!-- asset indicators -->
    <AssetIndicators></AssetIndicators>

    <!-- company specific data menu: tearsheet, insider transaction, ownership, sec filing -->
    <div class="company-data-menu">
      <ul class="company-data-menu-items">
        <li
          v-for="item in companyDataMenu"
          :class="['company-data-menu-item', {active: currentCompanyDataMenuItem === item.name}]"
          :key="item.name"
          @click="goToCompanySpecificData(item)"
        >{{item.name}}</li>
        <li class="company-data-menu-placeholder"></li>
      </ul>
    </div>

    <!-- company specific data content -->
    <keep-alive>
      <transition name="fade" mode="out-in">
        <router-view class="company-data-content"></router-view>
      </transition>
    </keep-alive>
  </div>
</template>

<script>
import AssetIndicators from "@/components/insight-page-components/asset-indicators";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "InsightCompanyPage",

  props: ["ticker"],

  components: {
    AssetIndicators,
    PulseLoader
  },

  computed: {
    ...mapState({
      assetInfo: state => state.PageService.assetInfo,
      companyDataMenu: state => state.PageService.companyDataMenu
    }),
    ...mapGetters(["isLogin"])
  },

  data() {
    return {
      currentCompanyDataMenuItem: "Tearsheet"
    };
  },

  mounted() {

    let temp = this.companyDataMenu.find(el => {
      let pathRegex = new RegExp("^" + el.link);
      return pathRegex.test(this.$route.path);
    });
    this.currentCompanyDataMenuItem = temp.name || "Tearsheet";

    // elastic search ticker
    this.$store
      .dispatch("elaticSearchForAssets", this.ticker)
      .then(res => res.json())
      .then(res => {
        // put the results which name equals search name in the first row
        let equal = res.filter(
          el => el.ticker.toLowerCase() === this.ticker.toLowerCase()
        )[0];
        return equal;
      })
      .then(equalInfo => {
        console.log(
          "[featured-news] setSearchTicker() equalInfo is: ",
          equalInfo
        );
        this.$store.commit("setAssetInfo", {
          ticker: equalInfo.ticker,
          name: equalInfo.companyName,
          exchange: equalInfo.exchange
        });
      })
      .catch(err => {
        console.log("setSearchTicker() ERROR is: ", err);
      });
  },

  methods: {
    goToCompanySpecificData(item) {
      // console.log("goToCompanySpecificData() item is: ", item);
      // this.$store.commit("setCurrentCompanyDataMenuItem", item.name);
      this.currentCompanyDataMenuItem = item.name;
      // TODO: better to use route names
      this.$router.push({ path: item.link + "/" + this.ticker });
    }
  }
};
</script>


<style scoped>
/*   For mobile screen   */
.asset-header-section {
  font-family: Raleway;
  padding-left: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #d8d8d8;
}

.asset-header {
  font-size: 0.8rem;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 0;
}

.asset-type {
  font-size: 0.625rem;
  font-weight: lighter;
  color: #918d8d;
}

/* company specific data menu styling */
.company-data-menu {
  font-family: Raleway;
  font-size: 0.8rem;
  border-bottom: 1px solid #d8d8d8;
}

.company-data-menu-items {
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.company-data-menu-item {
  width: 4.2rem;
  height: 2.5rem;
  line-height: 0.8rem;
  text-align: center;
  vertical-align: bottom;
  color: black !important;
  padding-top: 0.25rem;
  padding-bottom: 0.5rem;
  cursor: pointer;
}

.company-data-menu-placeholder {
  flex-grow: 1;
}

.company-data-menu-item.active {
  font-weight: bold;
  border-bottom: 1px solid black;
}

/* for desktop screen css */
@media (min-width: 768px) {
  .company-data-menu {
    font-size: 0.9rem;
    border-bottom: none;
  }

  .company-data-menu-items {
    padding-bottom: 0;
  }

  .company-data-menu-item {
    width: auto;
    height: 3.5rem;
    padding: 0.5rem;
    border-bottom: 1px solid #979797;
  }

  .company-data-menu-placeholder {
    display: inline-block;
    border-bottom: 1px solid #979797;
  }

  .company-data-menu-item.active {
    font-weight: bold;
    border: 1px solid #979797;
    border-bottom: none;
  }
}

@media (min-width: 992px) {
  .company-data-menu-item {
    padding: 0.5rem 1rem;
  }
  .asset-header {
    font-size: 1rem;
  }
}

@media (min-width: 1200px) {
  .asset-header-section {
    padding-left: 1.2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insight-pages/insight-company-page.vue